const apiUrl = process.env.REACT_APP_API_URL;

export async function PutProblemaRecompensa(idProblema: string, idRecompensa: string | number, recompensa: any) {
    const url = `${apiUrl}:8061/jutge/problema/${idProblema}/recompenses/${idRecompensa}`;
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(recompensa)
        });
        if (!response.ok) return false;
        return true;
    } catch (e) {
        return false;
    }
}
